/* eslint-disable */

import React from "react";

import { Size } from "../../logic/enums.ts";

import { ReactComponent as RaindropTitleSVG } from "./raindrop_title_v2.svg";
import VersionDisplay from "../version-display/version-display.js";

type RaindropTitleProps = {
  size: Size;
  isPrimary?: boolean;
  isIncludingVersion?: boolean;
  className?: string;
};

const RaindropTitle: React.FC<RaindropTitleProps> = ({
  size = Size.Medium,
  isPrimary = false,
  isIncludingVersion = false,
  className = "",
}) => {
  let titleHeight = "h-10";
  let color = "dark:fill-color-dark-text-primary fill-color-text-primary";

  switch (size) {
    case Size.Small:
      titleHeight = "h-10";
      break;
    case Size.Medium:
      titleHeight = "h-14";
      break;
    case Size.Large:
      titleHeight = "h-20";
      break;
    case Size.Huge:
      titleHeight = "h-20 md:h-28";
      break;
  }

  if (isPrimary) {
    color = "fill-color-raindrop-primary";
  }

  return (
    <div className={`flex flex-col items-center ${className}`}>
      <RaindropTitleSVG
        className={`${titleHeight} ${color} w-full ${className}`}
      />
      {isIncludingVersion && <VersionDisplay />}
    </div>
  );
};

export default RaindropTitle;
